import React from "react";

export interface PlayerPhotoSelectProps {
  name: string;
  onTakePhoto: () => void;
  onChooseAvatar: () => void;
  onBack: () => void;
}

export const PlayerPhotoSelect: React.FC<PlayerPhotoSelectProps> = ({
  name,
  onTakePhoto,
  onChooseAvatar,
  onBack,
}) => {
  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/fc-logo.svg"} width="125px" alt="Flight Club" />
      </div>
      <div className="contentCard-outer">
        <div className="contentCard">
          <div className="formContainer">
            <div className="formHeader">
              <div className="step">Step 2/3</div>
              <div className="title">Your photo</div>
            </div>
            <button className="white takePhotoBtn" onClick={onTakePhoto}>
              TAKE A PHOTO
            </button>
            <button className="no-background chooseAvatarBtn" onClick={onChooseAvatar}>
              Choose Avatar <img className="forward-arrow" src="./img/previous-arrow.svg" alt="" />
            </button>
          </div>
        </div>
        <span className="corner-bottom-left" />
        <span className="corner-bottom-right" />
      </div>
      <footer className="btn-container">
        <button className="small secondary with-back-arrow" onClick={onBack}>
          <img className="previous-arrow" src="./img/previous-arrow.svg" alt="" />
          BACK
        </button>
      </footer>
    </div>
  );
};
